import styled from 'styled-components';
import { ModalShareOfferSummaryStyled } from '../ModalShareOfferSummaryStyled';

export const ModalShareOfferSummaryStyledAP = styled(ModalShareOfferSummaryStyled)``;
